import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  chChatHistorySummarizerQuery as ChChatHistorySummarizerQuery,
} from "@/modules/patients/detail/progress-note/services/ch/__generated__/chChatHistorySummarizerQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query chChatHistorySummarizerQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    summarizeChatAppointment: ch_summarizeChatAppointment(aiRequestMetadata: $aiRequestMetadata) {
      text
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const chChatHistorySummarizerQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<ChChatHistorySummarizerQuery>(RelayEnvironment, query, {
    aiRequestMetadata,
  }).toPromise()
}
